import { Box, Skeleton, useMediaQuery } from '@mui/material'
import { Theme } from '@mui/material/styles'

/** Espelha o layout do JourneyShell enquanto a solicitação carrega. */
export function JourneySkeleton() {
  const desktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'))

  const fields = (
    <>
      <Skeleton width="70%" sx={{ fontSize: desktop ? 24 : 22 }} />
      <Skeleton width="90%" sx={{ mt: -1 }} />
      <Skeleton variant="rounded" height={56} />
      <Skeleton variant="rounded" height={56} />
      <Skeleton variant="rounded" height={56} />
    </>
  )

  if (!desktop) {
    return (
      <Box sx={{ px: 2, pt: 2, display: 'grid', gap: 2 }}>
        <Skeleton variant="rounded" height={6} />
        {fields}
        <Skeleton variant="rounded" height={52} sx={{ mt: 2 }} />
      </Box>
    )
  }

  return (
    <Box sx={{ pt: 2, pb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton width={120} sx={{ fontSize: 20 }} />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
          gap: 1,
          mb: 2,
        }}
      >
        {Array.from({ length: 5 }, (_, index) => (
          <Box key={index}>
            <Skeleton variant="rounded" height={6} />
            <Skeleton width="70%" />
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          p: 3.5,
          display: 'grid',
          gap: 2,
        }}
      >
        {fields}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
          <Skeleton variant="rounded" width={160} height={52} />
        </Box>
      </Box>
    </Box>
  )
}
